export const OPERATOR_NAME_RULES = [
  {
    test: (v) => v.trim().length > 0,
    message: 'Operator name is required',
  },
  {
    test: (v) => v.trim().length <= 100,
    message: 'Operator name must be 100 characters or fewer',
  },
  {
    test: (v) => /^[A-Za-z0-9 -]+$/.test(v.trim()),
    message: 'Only letters, numbers, spaces and hyphens are allowed',
  },
];

export const OPERATOR_CODE_RULES = [
  {
    test: (v) => v.trim().length > 0,
    message: 'Operator code is required',
  },
  {
    test: (v) => /^[A-Za-z]*$/.test(v.trim()),
    message: 'Only letters are allowed',
  },
  {
    test: (v) => v.trim().length === 2,
    message: 'Code must be exactly 2 letters',
  },
];

export const OPERATOR_DATE_RULES = [
  {
    test: (v) => v.trim().length > 0,
    message: 'Date is required',
  },
  {
    test: (v) => v <= '2100-12-31',
    message: 'Date must be on or before 31 Dec 2100',
  },
];
